export interface Pedido {
  id: number;
  orderCode: string;
  customerName: string;
  customerPhone: string;
  deliveryType: number;
  deliveryAddress: string | null;
  deliveryNotes: string | null;
  status: number;
  paymentMethod: number;
  notes: string | null;
  subtotalAmount: number;
  deliveryFee: number;
  totalAmount: number;
  createdAt: string;
  updatedAt: string;
  items: PedidoItem[];
}

export interface PedidoItem {
  id: number;
  productId: number;
  productName: string;
  unitPrice: number;
  quantity?: number;
  subtotal: number;
  notes: string | null;
  toppings?: PedidoItemTopping[];
}

export interface PedidoItemTopping {
  toppingId: number;
  toppingName: string;
  unitPrice: number;
  quantity: number;
  subtotal: number;
}

export enum EstadoPedido {
  Pendiente = 1,
  Preparando = 2,
  Listo = 3,
  Enviando = 4,
  Entregado = 5,
  Cancelado = 6,
}

export enum MetodoPago {
  Efectivo = 1,
  Tarjeta = 2,
  QR = 3,
}
